import { Box, TableCell, TableRow } from '@mui/material';
import { FC } from 'react';
import MediumTypography from '../../components/formlib/MediumTypography';
import { ReactComponent as ViewEye } from '../../assets/images/ViewEye.svg';
import ToolTipIcon from '../../components/formlib/ToolTipIcon';
import { ConsentListData } from '../../services/configApi/forms/Consent/ConsentServices';
import moment from 'moment';

interface ConsentProps {
  data: ConsentListData;
  onView: (rowData: ConsentListData) => void;
 }

const LeaTableRow: FC<ConsentProps> = (props) => {
  const {
    consentDate,
    isSchoolNameMandatory
     } = props.data;

  const renderCell = (
    content: string | null | undefined,
    format?: string,
    textColor?: string,
  ) => {
    if (!content || content === '') {
      return (
        <TableCell sx={{ padding: '0px' }}>
          <MediumTypography label="-" sxProps={{ textAlign: 'left' }} />
        </TableCell>
      );
    } else if (content === 'N/A') {
      return <MediumTypography label="N/A" sxProps={{ textAlign: 'left' }} />;
    }
    return (
      <MediumTypography
        label={format ? moment(content).local().format(format) : content}
        textColor={textColor}
      />
    );
  };



  return (
    <TableRow
      hover
      sx={{
        cursor: 'pointer',
        alignContent: 'flex-start',
        '&:nth-of-type(odd)': {
          backgroundColor: '#ECF9F8',
        },
      }}
    >
      <TableCell>{renderCell(consentDate, 'MM/DD/YYYY')}</TableCell>
      <TableCell>{renderCell(isSchoolNameMandatory ? 'No' : 'Yes')}</TableCell>
      <TableCell>
        <Box className="flex__">
          <Box
            className="cursorPointer"
            onClick={() => props.onView(props.data)}
          >
            <ToolTipIcon
              labelId="ConsentForms.listActionViewToolTipLabel"
              defaultLabel="View"
              cursor="pointer"
              Icon={<ViewEye />}
            />
          </Box>
        </Box>
      </TableCell>
    </TableRow>
  );
};

export default LeaTableRow;
